import React from "react";
import { Button } from "@/components/ui/button/Button";
import { useNotification } from "@/context/NotificationContext";
import { createWidgetConfig } from "@/services/api/widget";
import { useNavigate } from "react-router-dom";

interface SaveConfigButtonProps {
  pills: Array<{ type: string; value: string }>;
  entityId?: string;
  entityType?: string;
}

export const SaveConfigButton: React.FC<SaveConfigButtonProps> = ({
  pills,
  entityId,
  entityType,
}) => {
  const { showSuccess, showError } = useNotification();
  const navigate = useNavigate();

  const handleSaveConfig = async () => {
    try {
      // Filter pills to separate tags and search terms
      const tagPills = pills.filter((p) => p.type === "tag");
      const searchPills = pills.filter((p) => p.type === "search");

      // Create config object with just the filters
      const config = {
        filters: {
          tags: tagPills.map((p) => p.value),
          search_terms: searchPills.map((p) => p.value),
        },
        ...(entityId && entityType
          ? {
              entity: {
                id: entityId,
                type: entityType,
              },
            }
          : {}),
      };

      const response = await createWidgetConfig({
        type: "documents",
        name: "Saved Documents View",
        config,
      });

      const configUrl = `/documents?config=${response.config_id}`;

      showSuccess(
        "Successfully saved the current view configuration",
        "Your view has been saved and can be accessed later",
        {
          action: {
            label: "View Saved Configuration",
            onClick: () => navigate(configUrl),
          },
          duration: 16000,
        }
      );
    } catch (error) {
      console.error("Error saving config:", error);
      showError("Failed to save configuration");
    }
  };

  return (
    <Button onClick={handleSaveConfig} color="indigo" className="flex-none">
      Save Current View
    </Button>
  );
};
